import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";
import { SidebarProvider, useSidebar } from "./SidebarContext";

// Mobile Overlay Component
const MobileOverlay = () => {
  const { isOpen, closeSidebar } = useSidebar();
  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (!isMobile || !isOpen) return null;

    return (
    <div
      className="sidebar-overlay active"
      onClick={closeSidebar}
      aria-hidden="true"
    />
  );
};

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  return (
    <SidebarProvider>
      <Fragment>
        <NavHader />
        <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
        <Header
          onNote={() => onClick("chatbox")}
          onNotification={() => onClick("notification")}
          onProfile={() => onClick("profile")}
          toggle={toggle}
          title={title}
          onBox={() => onClick("box")}
          onClick={() => ClickToAddEvent()}
        />
        <MobileOverlay />
        <SideBar />
      </Fragment>
    </SidebarProvider>
  );
};

export default JobieNav;
